import {createContext} from 'react'

/**
 * @typedef {Object} AuthContextValue
 * @property {'loading'|'authed'|'invalid'|'error'} status
 * @property {import('../api/types.js').UserRecord|null} user
 * @property {() => Promise<void>} logout
 * @property {() => Promise<void>} refresh
 */

/** @type {React.Context<AuthContextValue>} */
export const AuthContext = createContext({
    status: 'loading',
    user: null,
    logout: async () => {},
    refresh: async () => {}
})
